import { APISIGO, APISIGOV2 } from "src/environments/environment";

export const Api = {
  //Conexion API
  ruta: APISIGO,
  rutaV2: APISIGOV2
};

